export default html => {

  if(!html || html == '') { return '' }

  return window.wp.shortcode.replace(
    'VAL',
    html,
    SC => {

      return `
      <span 
        class="playmotiv-shortcode"
        data-tag="${ SC.tag}"
        ${
          Object.keys(SC.attrs.named)
          .map(key => 'data-' +  key + '="' + SC.attrs.named[key] + '"')
          .join(' ')
        }
      >
        ${ SC.content || 'NO CONTENT' }
      </span>
      `
    }
  )
}